module.exports = __webpack_public_path__ + "fa-solid-900.9fe5a17c8ab036d20e6c.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/webfonts/fa-solid-900.woff
// module id = ../../../../../src/assets/fonts/webfonts/fa-solid-900.woff
// module chunks = styles